/**
 * Reads the landing page's "I came here to make an account" hint.
 *
 * Zero imports, per invariant 23: everything the console unit-tests must be
 * dependency-free, or the test runner ends up loading @solana/web3.js and the
 * native addons under it for the sake of one string check.
 *
 * This is a HINT, never a gate. `?account=1` highlights the sign-in control
 * that is always there anyway; it does not block the wallet, hide a panel, or
 * change what an anonymous visitor can do. Invariant 13 is the rule it must
 * not break.
 */
export function wantsAccount(search: string): boolean {
  // URLSearchParams tolerates a leading "?" and an empty string.
  return new URLSearchParams(search).get("account") === "1";
}
